import { render, staticRenderFns } from "./CounterText.vue?vue&type=template&id=19d0ec18"
import script from "./CounterText.vue?vue&type=script&lang=js"
export * from "./CounterText.vue?vue&type=script&lang=js"
import style0 from "./CounterText.vue?vue&type=style&index=0&id=19d0ec18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports